function GetcurrencySymbol() {
    let CurrencySign = "£";
    if(localStorage.getItem("Company") != null){
        var Company = JSON.parse(localStorage.getItem("Company"));
        if(Company.currency_type == "EUR"){CurrencySign = "€"}        
    }
    return CurrencySign;
  }
  export default GetcurrencySymbol;
